import * as React from "react";
import NextRouter from "next/router";
import { useBloomreachPageHasComponent, CmsContentPage, CmsComponentSlot, getPageRoot } from "@grandvisionhq/bloomreach";
import { WishlistButton } from "@grandvisionhq/fun-wishlist/button";
import { ProductBlockSlotsProvider } from "@grandvisionhq/lib-visuals";
import { AlgoliaConfigProvider } from "@grandvisionhq/search";
import "@grandvisionhq/products";
import "@grandvisionhq/svc-product-recommendations";
import { T as TealiumContentPageView } from "../TealiumContentPageView.js";
import { g as getAlgoliaConfig } from "../algolia.js";
import "@grandvisionhq/utils";
import { g as getServerUrl } from "../get-server-url.js";
const TealiumOptionalContentPageView = ({
  children
}) => {
  const isPlp = useBloomreachPageHasComponent({ componentName: "product-catalog-v2" });
  const Wrapper = isPlp ? React.Fragment : TealiumContentPageView;
  return /* @__PURE__ */ React.createElement(Wrapper, null, children);
};
const Page = (props) => {
  return /* @__PURE__ */ React.createElement(TealiumOptionalContentPageView, null, props.isContentPage || !props.algoliaConfig ? /* @__PURE__ */ React.createElement(CmsContentPage, null) : /* @__PURE__ */ React.createElement(AlgoliaConfigProvider, { ...props.algoliaConfig, router: NextRouter }, /* @__PURE__ */ React.createElement(
    ProductBlockSlotsProvider,
    {
      slots: {
        WishlistButton
      }
    },
    props.header,
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main" }),
    props.footer
  )));
};
Page.getInitialProps = async (context) => {
  const { req, asPath = "", pageModel, locale, isContentPage, featureToggles } = context;
  const serverUrl = getServerUrl(req);
  const {
    featureConfigs: { priceSegmentQueryKey = "", bloomreachRefPrefix },
    isMultilingualEnabled
  } = featureToggles;
  const priceSegmentCookie = req?.cookies[priceSegmentQueryKey];
  const pageRootComponent = getPageRoot(pageModel, bloomreachRefPrefix);
  if (!pageRootComponent) {
    return { statusCode: 500 };
  }
  const name = pageRootComponent.name;
  if (name === "pagenotfound") {
    return { statusCode: 404 };
  }
  const id = pageRootComponent.models.pageId;
  const type = pageRootComponent.models.pageType;
  if (!id && !type) {
    return { statusCode: 500 };
  }
  if (id === "pagenotfound" || type === "pagenotfound") {
    return { statusCode: 404 };
  }
  if (isContentPage) {
    return { isContentPage };
  }
  const breakpoint = req?.mediaQueryBreakpoint;
  const algoliaConfig = await getAlgoliaConfig({
    breakpoint,
    locale,
    clientQueryString: asPath,
    pageModel,
    serverUrl,
    router: NextRouter,
    refPrefix: bloomreachRefPrefix,
    isMultilingualEnabled
  });
  return {
    algoliaConfig: { ...algoliaConfig, priceSegmentCookie }
  };
};
export {
  Page
};
//# sourceMappingURL=container.js.map
